import { CommonEnums } from '../../common.enums';
import { Office365_Inst } from './office365_inst';
import { Conn_Db_Obj_Lnk } from '../conn_Db_Obj_Lnk';
import { DxFlow_Obj_Property } from './dxflow_obj_property';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Conn_Db_Obj_LnksUtil } from 'src/app/shared/utils/conn_db_obj_lnks.util';
import { DxFlow_Obj_PropertiesUtil } from 'src/app/shared/utils/dxflow_obj_properties.util';
import { Obj_Db_PropertyUtil } from 'src/app/shared/utils/obj_db_property.util';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';

export class Office365 {
    office365_Inst: Office365_Inst;
    conn_Db_Obj_Lnks: Array<Conn_Db_Obj_Lnk>;
    dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: string;
    column_Properties: Array<Obj_Db_Property>;
    office_Properties: Array<Obj_Db_Property>;
    target_Properties: Array<Obj_Db_Property>;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.office365_Inst = new Office365_Inst();
        this.conn_Db_Obj_Lnks = new Array<Conn_Db_Obj_Lnk>();
        this.dxFlow_Obj_Properties = new Array<DxFlow_Obj_Property>();
        this.change_Ind =  CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.STRING_EMPTY;
        this.column_Properties = new Array<Obj_Db_Property>();
        this.office_Properties = new Array<Obj_Db_Property>();
        this.target_Properties = new Array<Obj_Db_Property>();
    }

    static parse(office365Tmp: Office365): Office365 {
        let office365: Office365 = new Office365();
        office365.copyFrom(office365Tmp);
        return office365;
    }

    copy(): Office365 {
        let office365Tmp: Office365 = new Office365();

        office365Tmp.office365_Inst = this.office365_Inst.copy();
        office365Tmp.conn_Db_Obj_Lnks = Conn_Db_Obj_LnksUtil.getInstance().copy(this.conn_Db_Obj_Lnks);
        office365Tmp.dxFlow_Obj_Properties = DxFlow_Obj_PropertiesUtil.getInstance().copy(this.dxFlow_Obj_Properties);
        office365Tmp.change_Ind = this.change_Ind;
        office365Tmp.error_Cd = this.error_Cd;
        office365Tmp.error_Msg = this.error_Msg;
        office365Tmp.ref_Id = this.ref_Id;
        office365Tmp.ref_Cd = this.ref_Cd;
        office365Tmp.fldr_Id = this.fldr_Id;
        office365Tmp.column_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.column_Properties);
        office365Tmp.office_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.office_Properties);
        office365Tmp.target_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.target_Properties);
        return office365Tmp;
    }

    copyFrom(office365Tmp: Office365): void {
        this.office365_Inst.copyFrom(office365Tmp.office365_Inst);
        Conn_Db_Obj_LnksUtil.getInstance().copyFrom(this.conn_Db_Obj_Lnks, office365Tmp.conn_Db_Obj_Lnks);
        DxFlow_Obj_PropertiesUtil.getInstance().copyFrom(this.dxFlow_Obj_Properties, office365Tmp.dxFlow_Obj_Properties);
        this.change_Ind = office365Tmp.change_Ind;
        this.error_Cd = office365Tmp.error_Cd;
        this.error_Msg = office365Tmp.error_Msg;
        this.ref_Id = office365Tmp.ref_Id;
        this.ref_Cd= office365Tmp.ref_Cd;
        this.fldr_Id = office365Tmp.fldr_Id;
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.column_Properties, office365Tmp.column_Properties);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.office_Properties, office365Tmp.office_Properties);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.target_Properties, office365Tmp.target_Properties);

    }

    compare(office365Tmp: Office365): string {
        let diffString = '';
        diffString = (this.office365_Inst).compare(office365Tmp.office365_Inst);
        if (diffString != '') return diffString;

        diffString = Conn_Db_Obj_LnksUtil.getInstance().compare(this.conn_Db_Obj_Lnks, office365Tmp.conn_Db_Obj_Lnks);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.office_Properties, office365Tmp.office_Properties);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.column_Properties, office365Tmp.column_Properties);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.target_Properties, office365Tmp.target_Properties);
        if (diffString != '') return diffString;

        return diffString;
    }

    toString(): string {
        return "Office365 [office365_Inst=" + this.office365_Inst +
            ", conn_Db_Obj_Lnks=" + Conn_Db_Obj_LnksUtil.getInstance().toString(this.conn_Db_Obj_Lnks) +
            ", dxFlow_Obj_Properties=" + DxFlow_Obj_PropertiesUtil.getInstance().toString(this.dxFlow_Obj_Properties) +
            ", change_Ind=" + this.change_Ind +
            ", error_Cd=" + this.error_Cd +
            ", error_Msg=" + this.error_Msg +
            ", ref_Id=" + this.ref_Id +
            ", ref_Cd=" + this.ref_Cd +
            ", fldr_Id=" + this.fldr_Id +
            ", column_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.column_Properties) +
            ", office_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.office_Properties) +
            ", target_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.target_Properties) + "]"
    }
}